const initialState = {
  tasks: [],
};

const taskReducers = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_TASKS":
      return {
        ...state,
        tasks: action.payload,
      };
    default:
      return state;
  }
};

export default taskReducers;